<script setup lang="ts">
import type { NuxtError } from '#app'

definePageMeta({
  layout: 'blank',
  public: true,
})

defineProps<{ error: NuxtError }>()

const { loggedIn, clear } = useUserSession()

const onLogout = async () => {
  await clear()
  navigateTo('/welcome')
}
</script>

<template>
  <UError
    :error="{
      statusCode: error.statusCode,
      statusMessage: error.statusMessage || 'Oops',
      message: error.message || 'Something went wrong',
    }"
  >
    <template #links>
      <div class="grid w-40 gap-2 pt-12">
        <template v-if="loggedIn">
          <UButton to="/dashboard" block color="primary" variant="subtle">
            Back to home
          </UButton>
          <UButton block color="primary" variant="subtle" @click="onLogout">
            Logout
          </UButton>
        </template>

        <UButton v-else to="/welcome" block color="primary" variant="subtle">
          Clear error
        </UButton>
      </div>
    </template>
  </UError>
</template>
